@let chatButtonState = chatButtonState$ | async;

<div (finMutationObserver)="onDomChange($event)" #target></div>
@if (chatButtonState) {
  @switch (chatButtonState) {
    @case (HelpButtonStatus.CLICKED) {
      <fin-pre-chat />
    }
    @case (HelpButtonStatus.VISIBLE) {
      <button
        id="chat-help-button"
        (click)="chatTrigger(HelpButtonStatus.CLICKED)"
        class="fixed flex flex--center nordic-blue-900-bg surface-contrast white-text text-icon-reversed ps-small-x ps-xsmall-y align-left radius-xlarge-l font-label-medium"
        [class.dirty]="dirty$ | async"
        tabindex="0"
        [attr.aria-label]="'chat.defaultMinimizedText' | finLocalization"
      >
        <fcom-icon
          class="flex--nogrow icon-medium white-text text-icon-reversed"
          [dataTestId]="'icon-' + SvgLibraryIcon.CHAT"
          [name]="SvgLibraryIcon.CHAT"
          role="presentation"
        />
        <span class="dn-tablet-down ms-xxsmall-l">{{ 'chat.defaultMinimizedText' | finLocalization }}</span>
      </button>
    }
    @case (HelpButtonStatus.CHAT) {
      <div
        id="chat-help-loading"
        class="fixed flex flex--center nordic-blue-900-bg surface-contrast white-text text-icon-reversed ps-small-x ps-xsmall-y align-left radius-xlarge-l font-label-medium"
      >
        <fcom-loader [loaderType]="LoaderTheme.BUTTON" [color]="LoaderColor.WHITE" />
      </div>
    }
    @default {
      <!-- HIDDEN -->
    }
  }

  @if (renderAudioElement) {
    <audio id="agentforce-chat-notification" class="is-vishidden">
      <source src="https://cdn.finnair.com/chat/Notify.mp3" type="audio/mpeg" />
    </audio>
  }
}
